module.exports = __webpack_public_path__ + "static/media/Init.8988ab51.png";